"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlaceType = exports.isAdminType = exports.getAdmin = exports.getPrecisionKilometers = exports.LocationType = void 0;
var LocationType;
(function (LocationType) {
    LocationType[LocationType["COUNTRY"] = 0] = "COUNTRY";
    LocationType[LocationType["ADMIN1"] = 1] = "ADMIN1";
    LocationType[LocationType["ADMIN2"] = 2] = "ADMIN2";
    LocationType[LocationType["ADMIN3"] = 3] = "ADMIN3";
    LocationType[LocationType["ADMIN4"] = 4] = "ADMIN4";
    LocationType[LocationType["CITY"] = 5] = "CITY";
    LocationType[LocationType["POSTAL_CODE"] = 6] = "POSTAL_CODE";
    LocationType[LocationType["STATION"] = 7] = "STATION";
    LocationType[LocationType["AIRPORT"] = 8] = "AIRPORT";
    LocationType[LocationType["WATER"] = 9] = "WATER";
    LocationType[LocationType["POSTAL_PLACE"] = 10] = "POSTAL_PLACE";
    LocationType[LocationType["MISC"] = 11] = "MISC";
    LocationType[LocationType["PRECISE_LOCATION"] = 12] = "PRECISE_LOCATION";
})(LocationType = exports.LocationType || (exports.LocationType = {}));
const locationTypeDetails = {
    [LocationType.COUNTRY]: {
        defaultPrecisionKilometers: 2300,
        countryPrecisionKilometers: {},
        isAdminType: false,
        isPlaceType: false,
    },
    [LocationType.ADMIN1]: {
        defaultPrecisionKilometers: 360,
        countryPrecisionKilometers: {},
        isAdminType: true,
        isPlaceType: false,
    },
    [LocationType.ADMIN2]: {
        defaultPrecisionKilometers: 90,
        countryPrecisionKilometers: {},
        isAdminType: true,
        isPlaceType: false,
    },
    [LocationType.ADMIN3]: {
        defaultPrecisionKilometers: 90,
        countryPrecisionKilometers: {},
        isAdminType: true,
        isPlaceType: false,
    },
    [LocationType.ADMIN4]: {
        defaultPrecisionKilometers: 5,
        countryPrecisionKilometers: {},
        isAdminType: true,
        isPlaceType: false,
    },
    [LocationType.CITY]: {
        defaultPrecisionKilometers: 5,
        countryPrecisionKilometers: {},
        isAdminType: false,
        isPlaceType: true,
    },
    [LocationType.POSTAL_CODE]: {
        defaultPrecisionKilometers: 2,
        countryPrecisionKilometers: {},
        isAdminType: false,
        isPlaceType: false,
    },
    [LocationType.STATION]: {
        defaultPrecisionKilometers: 5,
        countryPrecisionKilometers: {},
        isAdminType: false,
        isPlaceType: true,
    },
    [LocationType.AIRPORT]: {
        defaultPrecisionKilometers: 5,
        countryPrecisionKilometers: {},
        isAdminType: false,
        isPlaceType: true,
    },
    [LocationType.WATER]: {
        defaultPrecisionKilometers: 5,
        countryPrecisionKilometers: {},
        isAdminType: false,
        isPlaceType: true,
    },
    [LocationType.POSTAL_PLACE]: {
        defaultPrecisionKilometers: 5,
        countryPrecisionKilometers: {},
        isAdminType: false,
        isPlaceType: true,
    },
    [LocationType.MISC]: {
        defaultPrecisionKilometers: 5,
        countryPrecisionKilometers: {},
        isAdminType: false,
        isPlaceType: true,
    },
    [LocationType.PRECISE_LOCATION]: {
        defaultPrecisionKilometers: 0.2,
        countryPrecisionKilometers: {},
        isAdminType: false,
        isPlaceType: true,
    },
};
const adminMap = new Map([
    [1, LocationType.ADMIN1],
    [2, LocationType.ADMIN2],
    [3, LocationType.ADMIN3],
    [4, LocationType.ADMIN4],
]);
/**
 * Get the precision of the given location type in the given country.
 *
 * @param type the location type to get the precision for
 * @param countryCode the country code for the country to get the precision for this location type
 * @return the precision for this location type (in kilometers) in the given country
 */
function getPrecisionKilometers(type, countryCode) {
    const details = locationTypeDetails[type];
    return details.countryPrecisionKilometers[countryCode] || details.defaultPrecisionKilometers;
}
exports.getPrecisionKilometers = getPrecisionKilometers;
/**
 * Gives the ADMIN LocationType corresponding to the given ordinal. Valid values are 1 to 4 inclusive.
 *
 * @param n the ordinal of the administrative type to get
 * @return the administrative type with the given ordinal
 * @throws RangeError if n is less than 1 or greater than 4
 */
function getAdmin(n) {
    const admin = adminMap.get(n);
    if (admin === undefined) {
        throw RangeError(`Bad admin value: ${n}; value must be in the range of 1 to 4`);
    }
    return admin;
}
exports.getAdmin = getAdmin;
/**
 * Determine if the given location type is an administrative division type.
 *
 * @param type the location type to check
 * @return true if the given location type is an administrative division type, false if not
 */
function isAdminType(type) {
    return locationTypeDetails[type].isAdminType;
}
exports.isAdminType = isAdminType;
/**
 * Determine if the given location type is a place type.
 *
 * @param type the location type to check
 * @return true if the given location type is a place type, false if not
 */
function isPlaceType(type) {
    return locationTypeDetails[type].isPlaceType;
}
exports.isPlaceType = isPlaceType;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9jYXRpb25UeXBlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0xvY2F0aW9uVHlwZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLFlBY1g7QUFkRCxXQUFZLFlBQVk7SUFDcEIscURBQU8sQ0FBQTtJQUNQLG1EQUFNLENBQUE7SUFDTixtREFBTSxDQUFBO0lBQ04sbURBQU0sQ0FBQTtJQUNOLG1EQUFNLENBQUE7SUFDTiwrQ0FBSSxDQUFBO0lBQ0osNkRBQVcsQ0FBQTtJQUNYLHFEQUFPLENBQUE7SUFDUCxxREFBTyxDQUFBO0lBQ1AsaURBQUssQ0FBQTtJQUNMLGdFQUFZLENBQUE7SUFDWixnREFBSSxDQUFBO0lBQ0osd0VBQWdCLENBQUE7QUFDcEIsQ0FBQyxFQWRXLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBY3ZCO0FBYUQsTUFBTSxtQkFBbUIsR0FBNkM7SUFDbEUsQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLEVBQUU7UUFDcEIsMEJBQTBCLEVBQUUsSUFBSztRQUNqQywwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxLQUFLO1FBQ2xCLFdBQVcsRUFBRSxLQUFLO0tBQ3JCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsTUFBTSxDQUFDLEVBQUU7UUFDbkIsMEJBQTBCLEVBQUUsR0FBRztRQUMvQiwwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxJQUFJO1FBQ2pCLFdBQVcsRUFBRSxLQUFLO0tBQ3JCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsTUFBTSxDQUFDLEVBQUU7UUFDbkIsMEJBQTBCLEVBQUUsRUFBRTtRQUM5QiwwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxJQUFJO1FBQ2pCLFdBQVcsRUFBRSxLQUFLO0tBQ3JCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsTUFBTSxDQUFDLEVBQUU7UUFDbkIsMEJBQTBCLEVBQUUsRUFBRTtRQUM5QiwwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxJQUFJO1FBQ2pCLFdBQVcsRUFBRSxLQUFLO0tBQ3JCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsTUFBTSxDQUFDLEVBQUU7UUFDbkIsMEJBQTBCLEVBQUUsQ0FBQztRQUM3QiwwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxJQUFJO1FBQ2pCLFdBQVcsRUFBRSxLQUFLO0tBQ3JCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsSUFBSSxDQUFDLEVBQUU7UUFDakIsMEJBQTBCLEVBQUUsQ0FBQztRQUM3QiwwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxLQUFLO1FBQ2xCLFdBQVcsRUFBRSxJQUFJO0tBQ3BCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsV0FBVyxDQUFDLEVBQUU7UUFDeEIsMEJBQTBCLEVBQUUsQ0FBQztRQUM3QiwwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxLQUFLO1FBQ2xCLFdBQVcsRUFBRSxLQUFLO0tBQ3JCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLEVBQUU7UUFDcEIsMEJBQTBCLEVBQUUsQ0FBQztRQUM3QiwwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxLQUFLO1FBQ2xCLFdBQVcsRUFBRSxJQUFJO0tBQ3BCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLEVBQUU7UUFDcEIsMEJBQTBCLEVBQUUsQ0FBQztRQUM3QiwwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxLQUFLO1FBQ2xCLFdBQVcsRUFBRSxJQUFJO0tBQ3BCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsS0FBSyxDQUFDLEVBQUU7UUFDbEIsMEJBQTBCLEVBQUUsQ0FBQztRQUM3QiwwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxLQUFLO1FBQ2xCLFdBQVcsRUFBRSxJQUFJO0tBQ3BCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsWUFBWSxDQUFDLEVBQUU7UUFDekIsMEJBQTBCLEVBQUUsQ0FBQztRQUM3QiwwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxLQUFLO1FBQ2xCLFdBQVcsRUFBRSxJQUFJO0tBQ3BCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsSUFBSSxDQUFDLEVBQUU7UUFDakIsMEJBQTBCLEVBQUUsQ0FBQztRQUM3QiwwQkFBMEIsRUFBRSxFQUFFO1FBQzlCLFdBQVcsRUFBRSxLQUFLO1FBQ2xCLFdBQVcsRUFBRSxJQUFJO0tBQ3BCO0lBQ0QsQ0FBQyxZQUFZLENBQUMsZ0JBQWdCLENBQUMsRUFBRTtRQUM3QiwwQkFBMEIsRUFBRSxHQUFHO1FBQy9CLDBCQUEwQixFQUFFLEVBQUU7UUFDOUIsV0FBVyxFQUFFLEtBQUs7UUFDbEIsV0FBVyxFQUFFLElBQUk7S0FDcEI7Q0FDSixDQUFDO0FBRUYsTUFBTSxRQUFRLEdBQUcsSUFBSSxHQUFHLENBQXVCO0lBQzNDLENBQUMsQ0FBQyxFQUFFLFlBQVksQ0FBQyxNQUFNLENBQUM7SUFDeEIsQ0FBQyxDQUFDLEVBQUUsWUFBWSxDQUFDLE1BQU0sQ0FBQztJQUN4QixDQUFDLENBQUMsRUFBRSxZQUFZLENBQUMsTUFBTSxDQUFDO0lBQ3hCLENBQUMsQ0FBQyxFQUFFLFlBQVksQ0FBQyxNQUFNLENBQUM7Q0FDM0IsQ0FBQyxDQUFDO0FBRUg7Ozs7OztHQU1HO0FBQ0gsU0FBZ0Isc0JBQXNCLENBQUMsSUFBa0IsRUFBRSxXQUFtQjtJQUMxRSxNQUFNLE9BQU8sR0FBRyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMxQyxPQUFPLE9BQU8sQ0FBQywwQkFBMEIsQ0FBQyxXQUFXLENBQUMsSUFBSSxPQUFPLENBQUMsMEJBQTBCLENBQUM7QUFDakcsQ0FBQztBQUhELHdEQUdDO0FBRUQ7Ozs7OztHQU1HO0FBQ0gsU0FBZ0IsUUFBUSxDQUFDLENBQVM7SUFDOUIsTUFBTSxLQUFLLEdBQUcsUUFBUSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQztJQUM5QixJQUFJLEtBQUssS0FBSyxTQUFTLEVBQUU7UUFDckIsTUFBTSxVQUFVLENBQUMsb0JBQW9CLENBQUMsd0NBQXdDLENBQUMsQ0FBQztLQUNuRjtJQUNELE9BQU8sS0FBSyxDQUFDO0FBQ2pCLENBQUM7QUFORCw0QkFNQztBQUVEOzs7OztHQUtHO0FBQ0gsU0FBZ0IsV0FBVyxDQUFDLElBQWtCO0lBQzFDLE9BQU8sbUJBQW1CLENBQUMsSUFBSSxDQUFDLENBQUMsV0FBVyxDQUFDO0FBQ2pELENBQUM7QUFGRCxrQ0FFQztBQUVEOzs7OztHQUtHO0FBQ0gsU0FBZ0IsV0FBVyxDQUFDLElBQWtCO0lBQzFDLE9BQU8sbUJBQW1CLENBQUMsSUFBSSxDQUFDLENBQUMsV0FBVyxDQUFDO0FBQ2pELENBQUM7QUFGRCxrQ0FFQyJ9